import * as angular from "angular";
import template from "./contact-info-modal.html";
import "./contact-info-modal.less";
import { EVENT_LOGOUT } from "../../constants";
import contactInfo, { type ContactInfo } from "./contact-info";

export interface ContactInfoModalResolve {
	contact: ContactInfo;
	isReadonly?: boolean;
}

interface ContactInfoModalInstance {
	close(contact: ContactInfo): void;
	dismiss(): void;
}

export interface ContactInfoModalController {
	modalInstance: ContactInfoModalInstance;
	resolve: ContactInfoModalResolve;
}

// eslint-disable-next-line no-redeclare
export class ContactInfoModalController {
	public static $inject = ["eventBus", "$scope"];

	public Contact!: ContactInfo;
	private isSettled = false;

	public constructor(
		private readonly eventBus,
		private readonly $scope: angular.IScope
	) {}

	public $onInit(): void {
		this.Contact = { ...this.resolve.contact };
		this.eventBus.register(EVENT_LOGOUT, () => this.cancel(), this.$scope);
	}

	public $onDestroy(): void {
		this.cancel();
	}

	public onOk(): void {
		if(this.isSettled) {
			return;
		}

		this.isSettled = true;
		this.modalInstance.close(this.Contact);
	}

	public cancel(): void {
		if(this.isSettled) {
			return;
		}

		this.isSettled = true;
		this.modalInstance.dismiss();
	}
}

export default angular
	.module("vesl.components.contact-info.contact-info-modal", [contactInfo])
	.component("contactInfoModal", {
		controller: ContactInfoModalController,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<",
			reload: "&"
		}
	})
	.name;
